import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	pageCount: {
		id: 'work-management-board.board.column.card.card-footer.confluence-pages.page-count',
		defaultMessage: '{pageCount} linked Confluence {pageCount, plural, one {page} other {pages}}',
		description: 'Lozenge shown to a user when hovering over linked Confluence pages button',
	},
});
